var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t("videocall.title.videocall_end")))]),_c('div',[_c('img',{attrs:{"src":_vm.logoUrl,"alt":"DivasPlay"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }